export const fallbackSearchTitle = 'Hva leter du etter?';
export const fallbackSearchPlaceholder = 'Søk';
export const fallbackPopularSearchTerms = ['Medlemskap', 'Veihjelp', 'EU-kontroll', 'Elbil', 'Service'];
